module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Chapter 1")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "flourish",
      "src": "images/flourish.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Two years later")])])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('span', {
    staticClass: "s3"
  }, [_vm._v("E")]), _vm._v("lise stared down at the letter from the Massachusetts National Bank, sucking on her lower lip and considering. Even now, her first instinct on seeing it had been to run to her father. Naturally, this would have been his responsibility were he still alive.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Her thoughts flickered next to her younger brother; however, she was loathe to bother him. She knew Reed had been strained over the past few years—not only taking over as head of the family, but a couple years prior to that, the girl he'd loved had fled the country in the wake of a particularly nasty scandal.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Good riddance")]), _vm._v(", Elise thought, having never liked Celia Amory.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Of course, Reed had willingly and effectively taken up the mantle of family patriarch after their father's untimely death a year earlier. Oliver Malloy's shockingly sudden passing after a brief illness had left them all reeling. Her brother had supported their mother with compassion and strength, set up his own law practice, and taken over the unenviable role of trying to keep his sisters safely out of harm's way while steering them toward happy, productive lives.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Currently, Reed was knee-deep in a high-profile trial that seemed to be going terribly wrong, while at the same time, he was considered the smart young lawyer who was supposed to make it right. He would be traveling to Portland, Maine, the very next day to depose a witness.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Elise fingered the thick cream-colored paper. Yes, Reed had enough on his sterling silver plate.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Her mother, who had sunk into a seclusion of deep grief from which she was only just emerging, was clearly overwhelmed by Elise's younger sisters: Sophie's latest desire to go overseas to study music had met with a lukewarm reaction from their mother, though Elise thought it was the best thing for her sister. Sophie, an accomplished pianist, would definitely rise to the occasion though she would have to get Reed on her side to make it happen.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Their mother worried about losing sight of any of her daughters, especially Rose, the little terror under their roof, an incorrigible flirt at age fifteen who was never beyond doing something impetuous.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Elise sighed. "), _c('i', [_vm._v("What to do?")]), _vm._v(" She could probably handle whatever it was herself. With a sense of foreboding, she broke the seal, opened the missive, and scanned it. However, she barely took in its meaning before the name at the bottom leaped off the page: "), _c('i', [_vm._v("Michael Bradley")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The letter could have come from any other officer of the bank, but it hadn't. It had come from "), _c('i', [_vm._v("him")]), _vm._v(", and it brought back her humiliation as if it were yesterday. Her father's discreet enquiry into Mr. Bradley's social situation had turned up the unwanted news that he was in fact seeing a woman, someone she vaguely knew by name. If that had been the end of it, it would have been nothing more than a minor misplacement of her curiosity.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("However, someone with a loose tongue had wagged it unforgivably into the young banker's ear. The next time she saw him while waiting at the courthouse for Reed to take her to lunch, Michael Bradley had ambushed her like a fox on a hen. In the middle of broad daylight, he'd approached her across the vast expanse of the lobby. Her welcoming smile froze and then died as, to Elise's intense mortification, he had thanked her for her interest in him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Her interest in him!")]), _vm._v(" Good God, she'd nearly died on the spot.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She still remembered the feeling of being unable to breathe while cool moisture seemed to break out all over her. Complete and utter humiliation. If he'd been a gentleman, he wouldn't have put her through it, but rather, he would have pretended to know nothing about the situation. If anything at all, he should have only vaguely smiled and nodded in her direction when he saw her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He'd even expressed an apology—an apology for what, she had no idea! She had felt sorry for the young lady with whom he was involved, if he was going to go around expressing regret over said involvement. And the whole time, he had a smile on his face as if thoroughly pleased with himself.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Cocky bastard")]), _vm._v(", she had thought to herself at the time.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Highly unappealing and again, not very gentlemanly. She'd barely stammered a useless denial when luckily, her brother had arrived to escort her to lunch. She'd been unable to even return Mr. Bradley's expression of good will and good day.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It had taken her a week to leave the house without ducking her head, imagining everyone was snickering at her behind their gloves and parasols—the girl who'd asked after Michael Bradley.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She had waited another year before going into the bank again, and that time, it was to accompany her mother after her father died. She'd made sure to stay well clear of the man's office and was grateful not to see hide nor hair of him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Suddenly, to read his name at the bottom of the letter that had been addressed simply to \"The Malloy Family,\" she felt startled by the unwelcome recollection. She began reading again from the beginning, but his words were obscure, even vague. All she knew was that a representative from their family needed to go to the bank for a meeting because of the \"impending circumstances\" regarding their house on Mount Vernon Street. There was no clue as to the reason, only an appointed day and time.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Frowning, Elise tossed the letter onto the buffet table in the front parlor and started to walk away. Thinking better of it, she picked it up once more, folded it carefully, and tucked it in the waistband of her skirt.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Reed would be furious if he found out she had hidden it from him, and truthfully, she hoped he would never find out. He was starting to look for a home of his own, something at the waterfront in a district their mother would never consider proper, but which Reed liked. If he thought his family's home was in peril, he would drop everything to focus on their well-being.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("No, she couldn't let him do that. He might jeopardize his career. She would simply meet with the man, herself. The vaguely menacing words might be a misunderstanding, and she could solve the problem with no one becoming the wiser.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Pouring a cup of coffee from the silver urn, she stirred in a spoonful of sugar and added some cream before sitting down alone in the sunshine of the lovely June morning. She picked up the "), _c('i', [_vm._v("Boston Post")]), _vm._v(", considering the front page without really seeing it. She felt a frisson of anxiety, like something unpleasant tickling her spine at the prospect of seeing Michael Bradley again. With a deep breath, she tamped the feeling down. A lot of time had passed, her father was gone, and she had matured. It didn't matter a whit to her what the man thought of her personally.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She'd never spoken with him again since that day at the courthouse. Of course, she'd run into him once or twice socially, or rather, avoided him at all costs if she spotted him at some event she was attending. Not that she'd been looking for him. But he had the sort of demeanor, tall and commanding, that stood out in a room, whether the large marbled foyer of the bank or one of Boston's treasured ballrooms.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("In some ways, he reminded her of Reed, both in his height, his presence, and his reputed intelligence. However, there was one thing about this overly confident, handsome—"), _c('i', [_vm._v("now why had that ridiculously irrelevant thought occurred to her?")]), _vm._v("—this banker that was nothing like her brother—he was arrogant, the essence of self-assuredness.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Cocky bastard,\" she muttered, finally focusing on the news story in front of her. "), _c('i', [_vm._v("The first Kentucky Derby winner at Churchill Downs in Louisville, KY. ")]), _vm._v("\""), _c('i', [_vm._v("...")]), _vm._v("the gallant Aristides, heir to a mighty name, that strides with sweeping gallop toward victory.\" And the horse wasn't even favored to place.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Suddenly, her mother was there, leaning over her shoulder, having entered on quiet, slippered feet. \"Ten thousand people in attendance! Goodness gracious,\" Evelyn Malloy said. \"But I thought you mentioned something about a cock fight.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Elise froze. \"No, Mama, a horse race. Come sit with me and have some coffee.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("* * *")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Elise alighted from her practical conveyance, a lovely little Palmer & Doucet two-seater carriage made on the north shore in West Amesbury. It gave her a measure of independence, despite the fact that she was as firmly under her brother's protection in her mother's house as she'd been under her father's before he died.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("One step, two steps along Devonshire Street, and she looked up at the daunting gray granite facade and graceful arches of the Massachusetts National Bank. Though nearly brand new, as most of the street had burned in the great fire just a few years earlier, it somehow managed to look ancient and imposing.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She swallowed, squaring her shoulders and adjusting her hat before she patted her favorite blue velvet purse with its silk cord handle and secure clip closure, assured that the cursedly ominous bank letter was secure inside it.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A bowler-clad doorman whisked open the door for her before she could even touch the handle. He bowed, she nodded, and then she hesitated. Normally, she would head toward a clerk, but today was different.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I'm here to see, Mr. Bradley,\" she told the man. \"I have an appointment.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Just so, Miss,\" he said, and gestured to another man, who nodded when the doorman instructed him, \"Please show this young lady to Mr. Bradley's office.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Elise followed the man with slicked back hair across the white marble floor, so shiny she could see her reflection as she looked down. She wore one of her favorite pale peach skirts and matching jacket, the color of which so well set off her dark hair, which all the Malloy children had inherited from their father's Irish side.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She wasn't trying to look her best or even impress Mr. Bradley. Of course not! She merely wanted the confidence that looking shipshape brought to her. But this skirt had a lovely draped bustle and a secondary overskirt in a slightly paler color of peach pulled narrowly around her legs. She felt quite put together.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Distracted by her heeled shoes clicking across the floor, she looked up to find herself in a small waiting area in front of a row of office doors. Here, the man left her with a small bow. Elise didn't have time to take a seat before the tall figure of Michael Bradley appeared in the doorway directly in front of her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He stopped still for a moment, his eyes widening, and then a broad smile spread over his face. His forward motion resumed, and he approached her, taking her hand in his even before she offered it. He held it a moment, looking down at her with the lovely fawnlike green-brown eyes she remembered, and it became hard to breathe.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Miss Malloy, isn't it?\" he asked in his deep voice, with barely a trace of a Boston accent.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes,\" she confirmed, and that was all she managed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Excuse me if I say that I'm surprised to see you. But not unpleasantly so.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Elise managed to get her brain working as he released her hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Why surprised, Mr. Bradley? You did send a letter to my home. And you couldn't expect my mother to come.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"No, but your brother—\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Is incredibly busy,\" she finished.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He frowned. \"Too busy to protect his family's estate?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She bristled, not liking the intimation that Reed wasn't looking out for his family's best interests. At the same time, her heart seemed to kick into her throat. What was the extent and seriousness of the problem? It sounded dire.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"He would have come if he'd known about the letter,\" she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Ah,\" Michael Bradley's face softened. \"I see. You've decided to come in his stead, and without giving him the opportunity.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Well... yes,\" Elise admitted. \"I share an equal interest in my family's well-being, and I like to think my mind is sharp enough to comprehend whatever you have to tell me.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Oh, I'm sure you're quite sharp enough, Miss Malloy. Won't you come this way?\" He gestured for her to precede him into his office with a wave of his arm and the slightest of bows. \"Please, take a seat,\" he added to the back of her, and she felt his sonorous voice run down her spine like fingertips.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Quickly, she took the closest seat, plushly upholstered in a dark and light blue brocade.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Would you care for some tea?\" he asked her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I prefer coffee,\" she said. Actually, at that moment, she'd prefer a glass of wine to calm her nerves, but she loved the taste of coffee. She watched him, specifically his large, capable hands, as he lifted the tureen from the sideboard and poured her a cup. He slid the china toward her, looking a little uncertain.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I usually take it light and sweet,\" she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"My apology.\" He frowned. \"The girl who normally offers the refreshments is out sick today. You're my first customer of the day.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Allow me,\" she said, reaching for the cup at the same moment that he did, feeling every nerve ending vibrate where his fingertips brushed against hers. She jumped and rattled the cup. His glance shot to hers, and for a moment, they just stared at each other.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("After an embarrassingly long interval, she lowered her gaze.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I'm so sorry,\" she uttered when she saw what she'd done. \"I've spilled coffee on your desk.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"My fault,\" he said, and it "), _c('i', [_vm._v("was")]), _vm._v(" his fault, she thought, for being so darned captivating.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("However, all she said was, \"No, it was entirely mine. If you just direct me to the amendments, I'll...\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("However, he had already grabbed a small glass sugar bowl and creamer from the sideboard and was placing them on the desk next to the spill. He looked around again as if expecting a towel to drop from the ceiling.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("After a brief hesitation, she watched him take a handkerchief out of his pocket and soak up the liquid, then drop the stained cloth next to the tureen.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Unable to stop looking at him, she managed to over-sweeten her coffee and make it positively white with too much milk.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"There, we've managed to sort that out,\" he said, as if they'd just discovered the cure for small pox.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Indeed,\" she said, relaxing a bit because he seemed so genuine and not nearly as insufferable as she'd imagined him to be.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("And then he ruined it by saying, \"So, your family has got itself into a bit of a situation, I'm afraid, but I have no doubt I can set it right.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There was the cockiness she'd always perceived in his self-possessed gaze. If he thought she was going to fall all over him with gratitude, he was sadly mistaken.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Precisely what "), _c('i', [_vm._v("is")]), _vm._v(" the situation? Perhaps my family can muddle through "), _c('i', [_vm._v("without")]), _vm._v(" your assistance.\" She leaned back, sipped the rich, slightly smoky-tasting beverage, and tried to look nonplussed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He frowned and cleared his throat. \"To be precise, a loan was taken out with this bank using your house as collateral. It has fallen into default. If you don't pay it in full within a month, then the bank takes your house.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She felt herself pale. The nauseating image of her mother on the front steps of their home with her trunks and furniture on the sidewalk appeared before Elise's eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Who took out the loan?\" she asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Why, your father, of course.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She shook her head. \"That's impossible. Father was incredibly successful. He was still booking clients just before he passed away.\" She remembered Reed offering to help some of them, though many thought her brother was too young to do the quality legal work of their father. He'd proven them all wrong.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"My brother doesn't know about this?\" It was a question, though she was sure the answer was no. If Reed had known, he would have discussed it with her at least, even if he'd kept it from their mother.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Michael Bradley shrugged. \"That I don't know. Your mother, of course, has inherited the liabilities of your father, as well as any assets. She must repay the loan or risk foreclosure. Do you know what that means?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He hadn't asked his question rudely, but rather as if he had a frank desire to explain everything to her. Still, it irked her. She set the coffee cup on his desk with a resounding clack.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Of course I do.\" She had no doubt Reed would pay off the loan himself, but probably at some financial hardship.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"May I see the documents, please, Mr. Bradley?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes, of course,\" he said, though she thought he had a slightly condescending expression on his face as though he doubted her ability to understand a legal contract.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Clearly, he had no idea what it was like to grow up in a family of lawyers. Elise watched him open a folder that was already lying atop his desk, pull out a few sheets of paper, and take the one off the top, which he then held out to her. \"This is the summation.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She took it, hoping her hand wasn't visibly trembling, and perused it, but when her eyes came to the amount, she couldn't contain the gasp of dismay.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Three thousand dollars! But what did my father need such a sum for?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"That, Miss Malloy, I cannot say. The bank does not ask why, only how much.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Good God! She shook her head, considering. How could they pay this off quickly enough to save their home without her father's income? Most certainly, they had that sum sitting in the bank, but it was a sizable amount, and no doubt it would cause them to alter their present lifestyle. And what of Sophie's music education?")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She looked up to see Michael Bradley's intense gaze fixed on her. She swallowed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You said you could 'set it right.' What did you mean by that?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It irritated her to ask him, bothered her even more to be beholden because until that moment, they were on an even footing. However, he didn't look smug as she had feared he would at her question. Instead, his countenance was one of concern.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Your family is well-known and has always been in good standing with this bank, since long before I came to work here. History bespeaks volumes in this case. I could take it up with the board of directors and ask them to extend the loan's deadline, create a new schedule of payments, something along the lines of a small monthly payment.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She nodded. "), _c('i', [_vm._v("Could it be so simple?")])])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("But there was something puzzling her. \"Where have the loan statements been going? To what address? Someone knew about this loan, someone who was ignoring the demands for payment.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She saw it then, a flicker, the merest shadow cross his face. He knew something else that he wasn't telling her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"There "), _c('i', [_vm._v("is")]), _vm._v(" a primary address,\" he said, \"a residence to where the loan payment requests have always gone. And payments were being made until your father's death. Then over the past year, the payments stopped, and the bank simply waited for the loan to go into default.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Will you give me that address?\" Elise asked before she even knew why. For whom had her father taken out a loan, and who would be so careless as to let it go unpaid for so long?")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Will you let me take you to dinner?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("His words reached her distracted brain a moment after he spoke them and caused her second gasp of the meeting.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I beg your pardon?\" she said. "), _c('i', [_vm._v("Had she heard him correctly?")])])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I asked if you will have dinner with me, Miss Malloy. Sometime. Soon.\" He finished his sentence with his hands clasped on the desk in front of him, his expression earnest—almost one of entreaty.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I...,\" she began, but found herself at a loss for words, reduced to clamping her lips closed in case she blurted out something stupid. "), _c('i', [_vm._v("Michael Bradley was asking her to dinner!")])])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He cocked his head at her hesitation. \"Will you give me your answer?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Hadn't they been discussing something vitally important before he had surprised all intelligent thought out of her head?")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Will you give me the address to where the loan statements have been sent?\" she asked again.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Are you saying yes to my invitation?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Was he coercing her into having dinner with him? And why wasn't that bothering her as it should? Especially given how he'd previously humiliated her in the courthouse lobby. Truthfully, his strange invitation didn't offend her. In fact, the idea that this very civilized man, in his well-tailored gray suit, would use such primitive tactics to be in her company was, she had to admit, more than a little thrilling.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Nevertheless, she couldn't let him know that. Any self-respecting woman ought to be outraged. Moreover, there was the certain fact that he fully expected her acquiescence, no doubt assuming she still had feelings for him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Try as she might, however, she could not work herself into high dudgeon over it. Yet being the eldest Malloy child and a proud one at that, she rose to her feet and decided to take umbrage.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Are you saying that your offer of assistance with this matter is contingent upon my taking an evening repast with you?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He stood up slowly, the earnest look gone, replaced by the shield of an emotionless mask. Instantly, she knew Michael Bradley displayed that guise to protect himself. She'd seen it on her brother, a reserved man who'd rather grind his molars than ever let anyone see when he felt vulnerable.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I'm saying that we have been... aware of each other for nearly two years. After spending only a few minutes in your company, I know that I'd like to become further acquainted with you. We could do that over dinner.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He paused and glanced out his office window before locking gazes with her again. \"I know that a woman of your quality probably has many suitors, so I suppose I am trying to make my own suit stand out. To such a purpose, I am putting it to you that I would be more likely to plead your case to the board if in turn you allowed me the opportunity to spend time with you.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She pursed her lips. That sounded like blackmail—though dinner with Michael Bradley seemed an easy price to pay.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Otherwise,\" he continued, \"I suppose you might discard my invitation out-of-hand. But with the added incentive, I assume you will consider it more strongly.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Her mouth had dropped slightly open. Why was this deliciously handsome man—she could no longer deny his good looks—stooping to such tactics? Was there any single female who would not accept his offer of dinner? She knew he had stopped seeing the young woman he'd been involved with at the time her father asked after him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Was there something wrong with him?")])])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Involuntarily, her gaze drifted down to the front of his trousers. As soon as she realized what she'd done, she hurriedly lifted it back up to his astounded face.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She felt her face heat up, no doubt richly colored with red. Did he think she was considering intimate relations with him to get his assistance? This had become almost farcical, and she had to put a stop to it at once.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I am afraid it is out of the question.\" "), _c('i', [_vm._v("Why?")]), _vm._v(" she berated herself. Because any woman who would let herself be coerced into spending time with a man was certainly no lady. Their relationship would be soiled from the start. "), _c('i', [_vm._v("What relationship?")])])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Why is it 'out of the question'?\" he asked, keeping his voice reasonable though she could tell he was not pleased by her refusal. \"You were interested in making my acquaintance at one time.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He had not brought that up again, had he? She felt her former humiliation keenly, as if it were only just happening. Hadn't he smiled smugly at her in front of everyone at the courthouse? Hadn't he embarrassed her beyond anything?")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("But what reason could she give for not going out with him? "), _c('i', [_vm._v("Think,")]), _vm._v(" she commanded herself. She certainly couldn't tell him her theory about starting a soiled relationship in case he had nothing long-term in mind. Her imagination had run too far ahead, and now she would have to invent an excuse.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Because I have a beau, and I am close to becoming engaged.\" Oh, goodness! Why had she said that? The words had rushed out almost of their own accord. She watched him frown, no doubt in disbelief, and she heard herself add, \"Indeed, it might happen at the Crowninshield's party this very weekend.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She watched his nostrils flare ever so slightly at the same time as his eyes narrowed. Then he seemed to dismiss his thoughts with a lift of his shoulder.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I see. My apologies for overstepping. It was meant actually partly in jest. Of course, you may have the address, and I will do my best for you when I speak with the board next week, regardless.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He crossed his arms.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Oh! So the blackmail was merely a jape. He was toying with her, and now she had given herself an imaginary suitor. Honestly, this sounded far more like something her youngest sister, Rose, would get herself into.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She blew at a stray lock of her hair that had found its way out from under her hat and fallen over her forehead.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("In the silence, his intense gaze seemed to observe the wayward tress lift up and settle back. Then he sat down again, pulled a clean sheet of paper from his desk, and begin to write. Efficiently, he blotted the ink, folded the paper, and moved around the desk. He held it out to her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She took it, making sure their fingers didn't touch this time. Despite the careful folds, she immediately opened it. Glancing down, she frowned. \"What about the name of the residence's owner?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He shook his head. \"We only had your father's name. No other.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She nodded.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Thank you, Mr. Bradley. I appreciate your assistance.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("However, if she thought she would escape without further consternation, she was wrong. First, he took her hand in his and held it, and the warmth of his touch scorched a trail right through her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I hope you did not take offense. I should have gone about that invitation differently. Had I known you were otherwise involved with someone, I wouldn't have presumed to ask you out at all. It was unknown to me that you had a firm alliance.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Had he been asking others about her?")])])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You did no harm, really.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She tugged her hand back.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I'll see you on Saturday evening,\" he added.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Her heart jolted, and then she recovered. \"Whatever do you mean?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I'm going to the same party. Crowninshield is my uncle. I'll enjoy meeting your beau,\" he added.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("In truth, she thought that he didn't sound particularly glad at all. For her part, she felt a wave of dread.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I, as well,\" she murmured.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I beg your pardon,\" he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I mean, I, too, shall enjoy introducing him to you.\" "), _c('i', [_vm._v("Please don't ask his name")]), _vm._v(", she prayed and was relieved when he didn't. She made it to the door, her brain already in a whirl as to how she would find a pretend suitor in just a few days.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Then a thought occurred to her. \"If you would be so kind, please don't mention the loan should you happen across another member of my family. At least, not until I can consider a solution. In any case, perhaps you will have success with the board. Then there will be no need to worry anyone.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He hesitated, but at last, he nodded ever so slightly.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Goodbye, Miss Malloy,\" he said, his gaze never wavering from hers.")])]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Good day, Mr. Bradley.\"")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23d5a9e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section7.vue
// module id = 78
// module chunks = 0